<template>
    <div>
        <!--loader - message--->
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
        <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
        <div class="clientProfile">
			<div class="mt-2 middleBox" v-if="(trans_id != '')"> 
					<app-OptVerfication :transaction_id="trans_id" :module="'16'" :title_parent="Title" :data="''" :ticketRequestFrom="'profileOtp'" :accountId="''"></app-OptVerfication>
			</div>
            <div class="middleBox" v-if="getUserProfile != '' && trans_id == ''">
                <div class="prifleName">
                    <div class="ico">
                        {{getUserProfile.firstname.charAt(0)}}{{getUserProfile.lastname.charAt(0)}}
                    </div>
                    <h3>{{getUserProfile.firstname}} {{getUserProfile.lastname}}</h3>
                    <div class="user_verification">
                        <span class="user_verified" v-if="get_user.step > 4"> {{$t('verified')}}</span>
                        <span class="not_verified" v-else-if="get_user.step > 2 && get_user.profile.total_points < 6"> {{$t('notEligible')}}</span>
                        <span class="not_verified" v-else> {{$t('completeRegSteps')}}</span>
                    </div>
                </div> 
				
                 <div class="fxtab" >
                     <div class="map-nav  whiteBG  border-bottom p-2 d-flex align-items-center justify-content-center mb-3">
                        <ul class="d-flex align-items-center">
                            <li :class="(tab == 'basic')?'active' : ''"><a href="#" @click="tab = 'basic'" >  {{$t('basicDetail')}}</a></li>
                            <li :class="(tab == 'address')?'active' : ''"><a href="#" @click="tab = 'address'" > {{$t('addressDetail')}}</a></li>
                            <li :class="(tab == 'bank')?'active' : ''"><a href="#" @click="tab = 'bank'" >{{$t('paymentDetail')}}</a></li> 
                            <li :class="(tab == 'doc')?'active' : ''"><a href="#" @click="tab = 'doc'" > {{$t('documents')}}</a></li> 
                        </ul>  
                    </div>   
                    <div class="inMiddle-area" >

                        <div class="personalForm list-group mb-4" v-if="tab == 'basic'">  
                            <div class="list-group-item">
                                <span> {{$t('fname')}}</span>
                                <span>{{getUserProfile.firstname}}</span>
                            </div>
                            <div class="list-group-item">
                                <span> {{$t('lname')}}</span>
                                <span>{{getUserProfile.lastname}}</span>
                            </div>
                            <div class="list-group-item">
                                <span> {{$t('emailaddress')}}</span>
                                <span>{{getUserProfile.email}}</span>
                            </div>
                            <div class="list-group-item">
                                <span> {{$t('phone')}}</span>
                                <span>{{getUserProfile.mobile_no}}</span>
                            </div>
                            <div class="list-group-item">
                                <span> {{$t('gender')}}</span>
                                <span>{{$t(genderList[getUserProfile.gender])}}</span>
                            </div>
                            <div class="list-group-item">
                                <span> {{$t('empStatus')}}</span>
                                <span>{{$t(empStatus[getUserProfile.emp_status])}}</span>
                            </div>
                            <div class="list-group-item">
                                <span> {{$t('occupation')}}</span>
                                <span>{{$t(occupationList[getUserProfile.occupation])}}</span>
                            </div>
                            <div class="list-group-item">
                                <span> {{$t('estYearlyIncome')}}</span>
                                <span>{{$t(estYearlyIncome[getUserProfile.yearly_income])}}</span>
                            </div>
                            <div class="list-group-item">
                                <span> {{$t('estNetWorth')}}</span>
                                <span>{{$t(estNetWorth[getUserProfile.net_worth])}}</span>
                            </div>
                            <div class="list-group-item">
                                <span>{{$t('accountTurnover')}}</span>
                                <span>{{$t(antAccountTurnover[getUserProfile.account_turnover])}}</span>
                            </div> 
                        </div> 
                        <div class="personalForm list-group mb-4" v-if="tab == 'address'"> 
                            <div class="list-group-item">
                                <span> {{$t('addressLine1')}}</span>
                                <span>{{getUserProfile.address1}}</span>
                            </div> 
                            <div class="list-group-item">
                                <span> {{$t('addressLine2')}}</span>
                                <span>{{getUserProfile.address2}}</span>
                            </div> 
                            <div class="list-group-item">
                                <span> {{$t('postCode')}}</span>
                                <span>{{getUserProfile.post_code}}</span>
                            </div> 
                            <div class="list-group-item"  v-for="clist in countriesList" v-if="clist.id == getUserProfile.nationality">
                                <span> {{$t('nationality')}}</span>
                                <span>{{clist.name}}</span>
                            </div> 
                            <div class="list-group-item" >
                                <span> {{$t('city')}}</span>
                                <span>{{getUserProfile.city}}</span>
                            </div>
                            <div class="list-group-item" v-for="clist in countriesList" v-if="clist.id == getUserProfile.residence_country">
                                <span> {{$t('resCountry')}}</span>
                                <span>{{clist.name}}</span>
                            </div> 
                        </div> 
                        <div class="personalForm list-group mb-4" v-if="tab == 'bank'">
							<div v-if="getUserProfile.banks.length > 0">
								<div v-for="(bankList,index) in getUserProfile.banks">
									<div class="mb-3" v-if="parseInt(bankList.method) == 1">
                                        <div class="list-group-item head d-flex justify-content-between align-items-center">
                                            <div>
                                                <p class="mr-3">
                                                    <strong> {{$t('bankName')}}</strong>
                                                    <span v-html="(bankList.bank_name != '' && bankList.bank_name != null)? bankList.bank_name : '-'"></span>
                                                </p>
                                                <p>
                                                    <strong> {{$t('AccNumber')}}</strong>
                                                    <span v-html="(bankList.account_no != '' && bankList.account_no != null)? bankList.account_no : '-'"></span>
                                                </p>
                                            </div>  
											<div>
                                                <a href="#" class="green mr-3" @click="detailDiv(index);">{{$t('viewDetail')}}</a>
                                                <a href="#" class="green" v-if="parseInt(bankList.status) == 2">{{$t('Pending')}}</a>
												<a href="#" class="green" @click="disable(bankList );" v-else>{{$t('Disable')}}</a>
                                            </div>
                                        </div>
										<div class="bottomInfo hide" :ref="'buttons'+index">
                                            <div class="list-group-item">
                                                <span> {{$t('paymentMethod')}}</span>
                                                <span><img class="ml-2" :src="'../../../../static/fxView/images/'+withdrawalMethod[bankList.method]" width="50" alt="Bank Account"></span>
                                            </div>  
                                            <div class="list-group-item">
                                                <span> {{$t('AccountName')}}</span>
                                                <span v-html="(bankList.holder_name != '' && bankList.holder_name != null)? bankList.holder_name : '-'"></span>
                                            </div>
                                            <div class="list-group-item">
                                                <span>{{$t('SwiftCode')}}</span>
                                                <span v-html="(bankList.sort_code != '' && bankList.sort_code != null)? bankList.sort_code : '-'"></span>
                                            </div>
                                            <div class="list-group-item">
                                                <span>{{$t('IBAN')}}</span>
                                                <span v-html="(bankList.micr != '' && bankList.micr != null)? bankList.micr : '-'"></span>
                                            </div>
                                            <div class="list-group-item">
                                                <span> {{$t('bankAdd')}}</span>
                                                <span v-html="(bankList.bank_address != '' && bankList.bank_address != null)? bankList.bank_address : '-'"></span>
                                            </div>                               
                                        </div>  
									</div> 
									<div class="mb-3" v-else-if="parseInt(bankList.method) == 2">
                                        <div class="list-group-item head align-items-center p-0"> 
                                            <div class="d-flex justify-content-start align-items-center">
                                                <p class="mr-3 border-right p-3 text-center">
                                                    <span><img   :src="'../../../../static/fxView/images/'+withdrawalMethod[bankList.method]" width="50" alt="Bank Account"></span>
                                                    <br>
                                                    <small> {{$t('paymentMethod')}}</small>
                                                </p> 
                                                <p>
                                                    <strong>{{$t('onlinePayId')}}:</strong>
                                                    <span>{{bankList.online_payment_id}}</span>
                                                </p>
                                                
                                            </div>
											<div class="p-3">
                                                <router-link :to="{name: 'fxView.support' , params: { 'tabName':'requestServiceElement','page':'profile', 'ticketData' : '16','method_id':'2'}}">Change</router-link>
                                            </div>
                                        </div> 
									</div>
									<div class="mb-3" v-else-if="parseInt(bankList.method) == 3">
                                        <div class="list-group-item head align-items-center p-0"> 
                                            <div class="d-flex align-items-center justify-content-start">
                                                <p class="mr-3 border-right p-3 text-center">
                                                    <span><img   :src="'../../../../static/fxView/images/'+withdrawalMethod[bankList.method]" width="50" alt="Bank Account"></span>
                                                    <br>
                                                    <small> {{$t('paymentMethod')}}</small>

                                                </p>
                                                <p class="mr-3">
                                                    <strong>{{$t('onlinePayId')}}:</strong>
                                                    <span>{{bankList.online_payment_id}}</span>
                                                </p> 
                                            </div> 
											<div class="p-3">
                                                <router-link :to="{name: 'fxView.support' , params: { 'tabName':'requestServiceElement','page':'profile', 'ticketData' : '16','method_id':'3'}}">Change</router-link>
                                            </div>
                                        </div> 
									</div>	
									<div class="mb-3" v-else-if="parseInt(bankList.method) == 5">
                                        <div class="list-group-item head align-items-center p-0"> 
                                            <div class="d-flex align-items-center justify-content-start">
                                                <div class="mr-3 border-right p-3 text-center">
                                                    <span><img   :src="'../../../../static/fxView/images/'+withdrawalMethod[bankList.method]" width="50" alt="Bank Account"></span> <br>
                                                    <small> {{$t('paymentMethod')}}</small>
                                                </div>
                                                <div>
                                                    <p>
                                                        <strong>{{$t('CreditCard')}}</strong>
                                                        <span> **** **** **** {{bankList.last_digit_card}}</span> <br>
                                                    </p>
                                                    <p>
                                                        <strong>{{$t('ExpiryDate')}}</strong>
                                                        <span> {{bankList.card_month}}/{{bankList.card_year}}</span> <br>
                                                    </p>
                                                </div>
                                            </div> 
											<div class="p-3">
												<a href="#" class="green" v-if="parseInt(bankList.status) == 2">{{$t('Pending')}}</a>
                                                <a href="#" class="green" @click="disable(bankList );" v-else>{{$t('Disable')}}</a>
                                            </div>
                                        </div> 
									</div>
																	
								</div>
							</div>
                            <div class="list-group mb-4" v-else>
                                <div class="list-group-item text-center">
                                    <span></span>
                                    <span> {{$t('noBankDetail')}}</span>
                                    <span></span>
                                </div> 
                            </div>
							<div class="addBank text-center mt-3">
								<router-link  class= "prism_btn d-inline-flex align-items-center" :to="{name: 'fxView.support' , params: { 'tabName':'requestServiceElement','page':'profile', 'ticketData' : '16','method_id':'1'}}">{{$t('AddBank')}}</router-link>
								<router-link class= "prism_btn d-inline-flex align-items-center" :to="{name: 'fxView.support' , params: { 'tabName':'requestServiceElement','page':'profile', 'ticketData' : '16','method_id':'5'}}">{{$t('AddCard')}}</router-link>
							</div>
                        </div> 
                        
                        
                        <div class="personalForm list-group  documentsListOuter" v-if="tab == 'doc'">
                            
                            <div class="documentsList list-group-item p-3" v-if="getUserProfile.documents.length > 0">
                                <div class="d_list" v-for="doc_list in getUserProfile.documents">
                                    <a :href="docsLink+'user&id='+getUserProfile.id+'&doc='+ doc_list.document" target="_blank()" v-if="doc_list.extension == 'pdf' || doc_list.extension == 'PDF' || doc_list.extension == 'application/pdf' || doc_list.extension == 'application/PDF'">
                                        <iframe :src = "docsLink+'user&id='+getUserProfile.id+'&doc='+ doc_list.document" target="_blank()"></iframe>
                                    </a> 
                                    <a :href="docsLink+'user&id='+getUserProfile.id+'&doc='+ doc_list.document" target="_blank()" v-else>
                                        <img :src="docsLink+'user&id='+getUserProfile.id+'&doc='+ doc_list.document" />
                                    </a>
                                </div>
                            </div>
                            <div class="twoBlock list-group mb-4 text-center" v-else>                                
                                <div class="list-group-item text-center">
                                    <span></span>
                                    <span> {{$t('noDocuments')}}</span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
		
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
	import optVerfication from '../supports/services/otp_verification'
    export default {
        name: 'profile',
        mixins: [fxViewMixins],
        data() {
            return {
				tab : 'basic',
                pageLoader : false,
                response_msg : '',
                msg_type : '',
                loaderFuncRun : '1',
				trans_id : '',
				Title : ''
            }
        },
		components: {
            appOptVerfication : optVerfication
        },
		methods:{
			detailDiv(index) {
                if ($(this.$refs['buttons'+index]).hasClass('hide')){
                    $(this.$refs['buttons'+index]).removeClass('hide');
                }else{
                    $(this.$refs['buttons'+index]).addClass('hide');
                }                
            },
			getUserProfileFunc(){
				 this._runGetUserProfile({'globalParams' :{},'localParams' :{ "parameter" : this , 'loaderFuncRun' : this.loaderFuncRun}})
			},
			disable(getData){
				let message = ''
				if(parseInt(getData.method) == 5){
					message = "kindly disable my credit card payment method, information as given below : "+ "\n" + "credit card number : **** **** **** "+ getData.last_digit_card + "\n" + "Expiry Date : "+ getData.card_month +"/"+ getData.card_year
				}else{
					message = "kindly disable my bank transfer payment method, information as given below : "+ "\n" + "Account Number : "+ getData.account_no 
				}
				this.Title = 112
				let jsonData = {
					'globalParams' :{
						"method_id": getData.id ,
						"method" : getData.method,
						"subject": "Disable Payment Method",
						"text": message,
						"reason": 16,
						"reason_text": 'Add Payment Method',
						"title": 112,
						"title_text": 'Disable Payment Method',
					},
					'localParams' :{ "parameter" : this }
				}
				this._runTicketRequestOtp(jsonData)
			}
		},
        created(){ 
            if(this.$store.getters[Const.GET_USER_PROFILE] != ''){
                this.loaderFuncRun = '0'
            }
            this.getUserProfileFunc()
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/users/profile.vue